var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQueries } from '@tanstack/react-query';
import { useAuthProvider } from '#context';
import { usePlugFilespaceClient } from '../../../hooks';
import { FilespaceEntryIdKeyFactory } from '../../../query-key-factories';
export const useFsEntriesGetKeys = ({ filespaceId, fsEntriesPaths, workspaceId, }) => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const queries = useQueries({
        queries: fsEntriesPaths.map((path) => ({
            queryKey: FilespaceEntryIdKeyFactory.exact(filespaceId, path),
            queryFn: async () => plugFilespaceClient({
                action: (fsClient) => fsClient.fileSystem().getEntryKey(path),
                filespaceId,
                workspaceId,
            }),
            enabled: Boolean(currentUser?.emailVerified),
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- pins 'always' to NetworkMode so useQueries options typecheck (lint:tsc needs it; projectService mis-judges as unnecessary)
            networkMode: 'always',
        })),
        combine: (results) => {
            return {
                data: results.map((result) => result.data),
                isPending: results.some((result) => result.isPending),
                isError: results.some((result) => result.isError),
            };
        },
    });
    return { queries };
};
_react_refresh_temp_1(useFsEntriesGetKeys, "Qd5Qea0MCxN5GS1qmA1OLhyv7Wo=", false, () => [useAuthProvider, usePlugFilespaceClient, useQueries]);
